export const PlanType = {
  PLAN: 'PLAN',
  BUILT_IN: 'BUILT_IN',
  SYSTEM: 'SYSTEM',
  RESERVED: 'RESERVED',
};

export const NAME_MAX_LENGTH = 100;
export const DESCRIPTION_MAX_LENGTH = 2000;
export const DOC_LABEL_MAX_LENGTH = 100;
export const DOC_LINK_MAX_LENGTH = 1000;
